import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from '@aando/core';
import { ru as ruLang } from '../locale/ru';
import { jp as jpLang } from '../locale/jp';
import { en as enLang } from '../locale/en';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly languageService = inject(LanguageService);
  private readonly title = `AANDO ID ${environment.stand}`;
  private readonly titleService = inject(Title);

  constructor() {
    const language = this.languageService.currentLanguage;
    this.titleService.setTitle(this.title);
    this.languageService.setLanguage(language);

    this.languageService.addLocales({
      en: enLang,
    });
    this.languageService.addLocales({
      jp: jpLang,
    });
    this.languageService.addLocales({
      ru: ruLang,
    });
  }
}
